import { DialogueResultType, DialogueVersionType, ReviewActiveType } from 'modules/review/review.enum';
import { DialogueInterface } from 'modules/review/review.interface';

export const getOpiconnectInfo = (
    dialogue: DialogueInterface | undefined,
    reviewStatus: ReviewActiveType | undefined,
    isRelatedToWithdrawnReview: boolean,
    companyName: string
): string => {
    if (dialogue?.version === DialogueVersionType.legacy) {
        const sentences = ['Komentarz został zareklamowany przez sklep.'];

        if (dialogue.isDialoguePublished) {
            sentences.push('Decyzją moderatora przebieg reklamacji został upubliczniony.');
        }

        return sentences.join(' ');
    }

    const sentences = dialogue
        ? [`Opinia ${dialogue.status === 'active' ? 'jest' : 'była'} przedmiotem dialogu w OpiConnect.`]
        : [];

    switch (dialogue?.result) {
        case DialogueResultType.reviewWithdrawnByUser:
            sentences.push('Strony osiągnęły porozumienie.');

            break;
        case DialogueResultType.notReadByUser:
            if (reviewStatus === ReviewActiveType.hiddenByComplaint) {
                sentences.push(`Użytkownik nie odczytał wiadomości od ${companyName} w wyznaczonym czasie.`);
            }

            break;
    }

    return sentences.join(' ');
};
